import { Title } from './styles';

const SectionTitle = ({ children, center }) => {
  return <Title center={center}>{children}</Title>;
};

export default SectionTitle;
